<div class="container">
  <mat-stepper
    orientation="vertical"
    [linear]="false"
    class="mat-elevation-z8"
    labelPosition="bottom"
    #savingProductStepper
  >
    <ng-template matStepperIcon="number">
      <fa-icon icon="pencil-alt" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="edit">
      <fa-icon icon="pencil-alt" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="done">
      <fa-icon icon="check" size="sm"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="error">
      <fa-icon icon="exclamation-triangle" size="lg"></fa-icon>
    </ng-template>

    <ng-template matStepperIcon="preview">
      <fa-icon icon="eye" size="sm"></fa-icon>
    </ng-template>

    <mat-step [stepControl]="savingProductDetailsForm" completed>
      <ng-template matStepLabel>{{ 'labels.inputs.DETAILS' | translate }}</ng-template>

      <LOSx-saving-product-details-step
        [savingProductsTemplate]="savingProductAndTemplate"
      ></LOSx-saving-product-details-step>
    </mat-step>

    <mat-step [stepControl]="savingProductCurrencyForm" completed>
      <ng-template matStepLabel>{{ 'labels.inputs.CURRENCY' | translate }}</ng-template>

      <LOSx-saving-product-currency-step
        [savingProductsTemplate]="savingProductAndTemplate"
      ></LOSx-saving-product-currency-step>
    </mat-step>

    <mat-step [stepControl]="savingProductTermsForm" completed>
      <ng-template matStepLabel>{{ 'labels.inputs.TERMS' | translate }}</ng-template>

      <LOSx-saving-product-terms-step
        [savingProductsTemplate]="savingProductAndTemplate"
      ></LOSx-saving-product-terms-step>
    </mat-step>

    <mat-step [stepControl]="savingProductSettingsForm" completed>
      <ng-template matStepLabel>{{ 'labels.inputs.SETTINGS' | translate }}</ng-template>

      <LOSx-saving-product-settings-step
        [savingProductsTemplate]="savingProductAndTemplate"
      ></LOSx-saving-product-settings-step>
    </mat-step>

    <mat-step completed>
      <ng-template matStepLabel>{{ 'labels.inputs.CHARGES' | translate }}</ng-template>

      <LOSx-saving-product-charges-step
        [savingProductsTemplate]="savingProductAndTemplate"
        [currencyCode]="savingProductCurrencyForm.get('currencyCode')"
      >
      </LOSx-saving-product-charges-step>
    </mat-step>

    <mat-step [stepControl]="savingProductAccountingForm" completed>
      <ng-template matStepLabel>{{ 'labels.inputs.ACCOUNTING' | translate }}</ng-template>

      <LOSx-saving-product-accounting-step
        [savingProductsTemplate]="savingProductAndTemplate"
        [accountingRuleData]="accountingRuleData"
        [isDormancyTrackingActive]="savingProductSettingsForm.get('isDormancyTrackingActive')"
        [savingProductFormValid]="savingProductFormValidAndNotPristine"
        [allowOverdraft]="savingProductSettingsForm.get('allowOverdraft')"
      >
      </LOSx-saving-product-accounting-step>
    </mat-step>

    @if (savingProductFormValidAndNotPristine) {
      <mat-step state="preview" completed>
        <ng-template matStepLabel>{{ 'labels.inputs.PREVIEW' | translate }}</ng-template>
        <LOSx-saving-product-preview-step
          [savingProductsTemplate]="savingProductAndTemplate"
          [accountingRuleData]="accountingRuleData"
          [savingProduct]="savingProduct"
          [taskPermission]="'UPDATE_SAVINGSPRODUCT'"
          (submitEvent)="submit()"
        >
        </LOSx-saving-product-preview-step>
      </mat-step>
    }
  </mat-stepper>
</div>
